import React, { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import { Card, CardBody, CardHeader } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import apiService from '../../../Auth/apiService.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';

ChartJS.register(ArcElement, ChartTooltip, Legend);

function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}


export default function VerEstadisticos(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState();
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const [datos, setDatos] = useState(null);

    
    useEffect(() => {
        // helper to format yyyy-mm-dd
        const fmt = (d) => d.toISOString().slice(0,10);

        const today = new Date();
        
        // Previous period: first day to last day of the month before previous
        const startDate = new Date(today.getFullYear(), 0, 1);
        const endDate = today;

        // Only set defaults if not already set by user
        setStart((v) => v || fmt(startDate));
        setEnd((v) => v || fmt(endDate));
        
    }, []);
    
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function fetchDatos(start, end) {
        if (!start || !end) {
            Mensaje('Fechas incompletas', 'Por favor complete las cuatro fechas antes de generar el reporte.');
            return;
        }
        const obj = {
            start: start,
            end: end
        }
        const url = `/consultas/estadisticos`; 
        setCargando(true);
        await apiService.post(url, obj, token)
        .then((response) => {
            const datos = response.data;
            setDatos(datos);
        })
        .catch((error) => {
            Mensaje('Error al obtener datos', 'Ocurrió un error al obtener los datos estadísticos. ' + error.message);
        })
        .finally(() => {
            setCargando(false);
        });
    }

    const beneficiariosReporte = Array.isArray(datos?.totalBeneficiarios)
        ? datos.totalBeneficiarios[0]
        : {};
    const totalBeneficiarios = Number(beneficiariosReporte?.cantidad || 0);
    const totalIncluidos = Number(beneficiariosReporte?.incluido || 0);
    const totalValoraciones = Number(beneficiariosReporte?.valoracion || 0);
    const porcentajeIncluidos = totalBeneficiarios > 0
        ? ((totalIncluidos / totalBeneficiarios) * 100).toFixed(2)
        : '0.00';
    const porcentajeValoraciones = totalBeneficiarios > 0
        ? ((totalValoraciones / totalBeneficiarios) * 100).toFixed(2)
        : '0.00';
    let beneficiariosPorSexo = [];
    if (Array.isArray(datos?.beneficiariosPorSexo)) {
        beneficiariosPorSexo = datos.beneficiariosPorSexo;
    } else if (Array.isArray(datos?.beneficiariosSexo)) {
        beneficiariosPorSexo = datos.beneficiariosSexo;
    }

    let beneficiariosOrientacionSexual = [];
    if (Array.isArray(datos?.beneficiariosOrientacionSexual)) {
        beneficiariosOrientacionSexual = datos.beneficiariosOrientacionSexual;
    } else if (Array.isArray(datos?.beneficiariosPorOrientacionSexual)) {
        beneficiariosOrientacionSexual = datos.beneficiariosPorOrientacionSexual;
    } else if (Array.isArray(datos?.orientacionSexual)) {
        beneficiariosOrientacionSexual = datos.orientacionSexual;
    }

    let beneficiariosIdentidadGenero = [];
    if (Array.isArray(datos?.beneficiariosIdentidadGenero)) {
        beneficiariosIdentidadGenero = datos.beneficiariosIdentidadGenero;
    } else if (Array.isArray(datos?.beneficiariosPorIdentidadGenero)) {
        beneficiariosIdentidadGenero = datos.beneficiariosPorIdentidadGenero;
    } else if (Array.isArray(datos?.identidadGenero)) {
        beneficiariosIdentidadGenero = datos.identidadGenero;
    }

    let beneficiariosEtnias = [];
    if (Array.isArray(datos?.beneficiariosPorEtnia)) {
        beneficiariosEtnias = datos.beneficiariosPorEtnia;
    } else if (Array.isArray(datos?.beneficiariosPorEtnias)) {
        beneficiariosEtnias = datos.beneficiariosPorEtnias;
    } else if (Array.isArray(datos?.etnias)) {
        beneficiariosEtnias = datos.etnias;
    }

    let beneficiariosDiscapacidades = [];
    if (Array.isArray(datos?.beneficiariosPorDiscapacidad)) {
        beneficiariosDiscapacidades = datos.beneficiariosPorDiscapacidad;
    } else if (Array.isArray(datos?.beneficiariosDiscapacidades)) {
        beneficiariosDiscapacidades = datos.beneficiariosDiscapacidades;
    } else if (Array.isArray(datos?.discapacidades)) {
        beneficiariosDiscapacidades = datos.discapacidades;
    }

    const totalBeneficiariosSexo = beneficiariosPorSexo.reduce(
        (acc, item) => acc + Number(item?.cantidad || 0),
        0
    );
    const basePorcentajeSexo = totalBeneficiarios > 0 ? totalBeneficiarios : totalBeneficiariosSexo;

    const totalBeneficiariosOrientacion = beneficiariosOrientacionSexual.reduce(
        (acc, item) => acc + Number(item?.cantidad || 0),
        0
    );
    const basePorcentajeOrientacion = totalBeneficiarios > 0 ? totalBeneficiarios : totalBeneficiariosOrientacion;

    const totalBeneficiariosIdentidad = beneficiariosIdentidadGenero.reduce(
        (acc, item) => acc + Number(item?.cantidad || 0),
        0
    );
    const basePorcentajeIdentidad = totalBeneficiarios > 0 ? totalBeneficiarios : totalBeneficiariosIdentidad;

    const totalBeneficiariosEtnias = beneficiariosEtnias.reduce(
        (acc, item) => acc + Number(item?.cantidad || 0),
        0
    );
    const basePorcentajeEtnias = totalBeneficiarios > 0 ? totalBeneficiarios : totalBeneficiariosEtnias;

    const totalBeneficiariosDiscapacidades = beneficiariosDiscapacidades.reduce(
        (acc, item) => acc + Number(item?.cantidad || 0),
        0
    );
    const basePorcentajeDiscapacidades = totalBeneficiarios > 0 ? totalBeneficiarios : totalBeneficiariosDiscapacidades;

    let beneficiariosEtareos = [];
    if (Array.isArray(datos?.beneficiariosPorEtareos)) {
        beneficiariosEtareos = datos.beneficiariosPorEtareos;
    } else if (Array.isArray(datos?.gruposEtareos)) {
        beneficiariosEtareos = datos.gruposEtareos;
    } else if (Array.isArray(datos?.etareos)) {
        beneficiariosEtareos = datos.etareos;
    }

    const totalBeneficiariosEtareos = beneficiariosEtareos.reduce(
        (acc, item) => acc + Number(item?.cantidad || 0),
        0
    );
    const basePorcentajeEtareos = totalBeneficiarios > 0 ? totalBeneficiarios : totalBeneficiariosEtareos;
    const formatoNumero = (valor) => new Intl.NumberFormat('es-CO').format(valor || 0);

    const graficaSexoData = {
        labels: beneficiariosPorSexo.map((item) => capitalize(String(item?.sexo || 'Sin Info'))),
        datasets: [
            {
                label: 'Beneficiarios por sexo',
                data: beneficiariosPorSexo.map((item) => Number(item?.cantidad || 0)),
                backgroundColor: ['#9ad9cf', '#f5b8d0', '#c4b5fd', '#f7d9a8', '#a7c7f9'],
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    };

    const graficaSexoOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 14,
                    padding: 14,
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Number(context.parsed || 0);
                        const porcentaje = basePorcentajeSexo > 0
                            ? ((value / basePorcentajeSexo) * 100).toFixed(2)
                            : '0.00';
                        return `${context.label}: ${formatoNumero(value)} (${porcentaje}%)`;
                    },
                },
            },
        },
    };

    const graficaOrientacionData = {
        labels: beneficiariosOrientacionSexual.map((item) => capitalize(String(item?.ori_orientacionsexual || 'Sin Info'))),
        datasets: [
            {
                label: 'Beneficiarios por orientación sexual',
                data: beneficiariosOrientacionSexual.map((item) => Number(item?.cantidad || 0)),
                backgroundColor: ['#9ad9cf', '#f5b8d0', '#c4b5fd', '#f7d9a8', '#a7c7f9', '#f3c99f', '#b9e4ce'],
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    };

    const graficaOrientacionOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 14,
                    padding: 14,
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Number(context.parsed || 0);
                        const porcentaje = basePorcentajeOrientacion > 0
                            ? ((value / basePorcentajeOrientacion) * 100).toFixed(2)
                            : '0.00';
                        return `${context.label}: ${formatoNumero(value)} (${porcentaje}%)`;
                    },
                },
            },
        },
    };

    const graficaIdentidadData = {
        labels: beneficiariosIdentidadGenero.map((item) => capitalize(String(item?.ide_identidad || 'Sin Info'))),
        datasets: [
            {
                label: 'Beneficiarios por identidad de género',
                data: beneficiariosIdentidadGenero.map((item) => Number(item?.cantidad || 0)),
                backgroundColor: ['#9ad9cf', '#f5b8d0', '#c4b5fd', '#f7d9a8', '#a7c7f9', '#f3c99f', '#b9e4ce', '#ffd9e6', '#d9ecff', '#e7d8b4'],
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    };

    const graficaIdentidadOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 14,
                    padding: 14,
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Number(context.parsed || 0);
                        const porcentaje = basePorcentajeIdentidad > 0
                            ? ((value / basePorcentajeIdentidad) * 100).toFixed(2)
                            : '0.00';
                        return `${context.label}: ${formatoNumero(value)} (${porcentaje}%)`;
                    },
                },
            },
        },
    };

    const graficaEtniasData = {
        labels: beneficiariosEtnias.map((item) => capitalize(String(item?.min_minoria || 'Sin Info'))),
        datasets: [
            {
                label: 'Beneficiarios por etnia',
                data: beneficiariosEtnias.map((item) => Number(item?.cantidad || 0)),
                backgroundColor: ['#9ad9cf', '#f5b8d0', '#c4b5fd', '#f7d9a8', '#a7c7f9', '#f3c99f', '#b9e4ce', '#ffd9e6', '#d9ecff'],
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    };

    const graficaEtniasOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 14,
                    padding: 14,
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Number(context.parsed || 0);
                        const porcentaje = basePorcentajeEtnias > 0
                            ? ((value / basePorcentajeEtnias) * 100).toFixed(2)
                            : '0.00';
                        return `${context.label}: ${formatoNumero(value)} (${porcentaje}%)`;
                    },
                },
            },
        },
    };

    const graficaDiscapacidadesData = {
        labels: beneficiariosDiscapacidades.map((item) => capitalize(String(item?.dis_discapacidad || 'Sin info'))),
        datasets: [
            {
                label: 'Beneficiarios por discapacidades',
                data: beneficiariosDiscapacidades.map((item) => Number(item?.cantidad || 0)),
                backgroundColor: ['#9ad9cf', '#f5b8d0', '#c4b5fd', '#f7d9a8', '#a7c7f9', '#f3c99f', '#b9e4ce', '#ffd9e6', '#d9ecff', '#e7d8b4'],
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    };

    const graficaDiscapacidadesOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 14,
                    padding: 14,
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Number(context.parsed || 0);
                        const porcentaje = basePorcentajeDiscapacidades > 0
                            ? ((value / basePorcentajeDiscapacidades) * 100).toFixed(2)
                            : '0.00';
                        return `${context.label}: ${formatoNumero(value)} (${porcentaje}%)`;
                    },
                },
            },
        },
    };

    const graficaEtareosData = {
        labels: beneficiariosEtareos.map((item) =>
            (item?.etareos || 'Sin Info').replace(/^\d/u, '').replaceAll('_', ' ').trim()
        ),
        datasets: [
            {
                label: 'Beneficiarios por grupo etáreo',
                data: beneficiariosEtareos.map((item) => Number(item?.cantidad || 0)),
                backgroundColor: ['#9ad9cf', '#f5b8d0', '#c4b5fd', '#f7d9a8', '#a7c7f9', '#f3c99f', '#b9e4ce'],
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    };

    const graficaEtareosOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 14,
                    padding: 14,
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Number(context.parsed || 0);
                        const porcentaje = basePorcentajeEtareos > 0
                            ? ((value / basePorcentajeEtareos) * 100).toFixed(2)
                            : '0.00';
                        return `${context.label}: ${formatoNumero(value)} (${porcentaje}%)`;
                    },
                },
            },
        },
    };

    async function ExportaExcel(datos) {
        setCargando(true);
        import('xlsx').then(XLSX => {
            const totalBeneficiarios = XLSX.utils.json_to_sheet(datos?.totalBeneficiarios || []);
            const beneficiariosPorSexo = XLSX.utils.json_to_sheet(datos?.beneficiariosPorSexo || []);
            const beneficiariosPorEtnia = XLSX.utils.json_to_sheet(datos?.beneficiariosPorEtnia || []);
            const beneficiariosPorEtareos = XLSX.utils.json_to_sheet(datos?.beneficiariosPorEtareos || []);
            const beneficiariosPorDiscapacidad = XLSX.utils.json_to_sheet(datos?.beneficiariosPorDiscapacidad || []);
            const beneficiariosOrientacionSexual = XLSX.utils.json_to_sheet(datos?.beneficiariosOrientacionSexual || []);
            const beneficiariosIdentidadGenero = XLSX.utils.json_to_sheet(datos?.beneficiariosIdentidadGenero || []);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, totalBeneficiarios, 'Total');
            XLSX.utils.book_append_sheet(workbook, beneficiariosPorSexo, 'Sexo');
            XLSX.utils.book_append_sheet(workbook, beneficiariosPorEtnia, 'Etnia');
            XLSX.utils.book_append_sheet(workbook, beneficiariosPorEtareos, 'Grupo Etáreo');
            XLSX.utils.book_append_sheet(workbook, beneficiariosPorDiscapacidad, 'Discapacidad');
            XLSX.utils.book_append_sheet(workbook, beneficiariosOrientacionSexual, 'Orientación Sexual');
            XLSX.utils.book_append_sheet(workbook, beneficiariosIdentidadGenero, 'Identidad Género');
            XLSX.writeFile(workbook, `inf_${datos?.FechaInicio.split('T')[0]}_${datos?.FechaFin.split('T')[0]}.xlsx`);
            setCargando(false);
        });

    }

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Estadisticos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Estadisticos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <Card>
                        <CardHeader>
                            <h3 className="card-title">
                                Seleccione el rango de fechas para ver los estad&iacute;sticos de caracterizaci&oacute;n.
                            </h3>
                        </CardHeader>
                        <CardBody>
                            <div className="row" style={{ gap: '10px' }}>
                                <div className="col-md-2" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <div className="form-group">
                                        <label htmlFor="start">Fecha inicio</label>
                                        <input
                                            id="start"
                                            type="date"
                                            className="form-control"
                                            value={start}
                                            onChange={(e) => setStart(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <div className="form-group">
                                        <label htmlFor="end">Fecha fin</label>
                                        <input
                                            id="end"
                                            type="date"
                                            className="form-control"
                                            value={end}
                                            onChange={(e) => setEnd(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2" style={{ display: 'flex', alignItems: 'end' }}>
                                    <div className="form-group">
                                        <button
                                            className="btn btn-primary"
                                            disabled={Cargando}
                                            onClick={() => {
                                                fetchDatos(start, end);
                                            }}
                                        >
                                            {Cargando ? 'Cargando...' : 'Ver estadísticos'}
                                        </button>
                                    </div>
                                </div>
                                {datos && <div className="col-md-4" style={{ display: 'flex', alignItems: 'end' }}>
                                    <div className="form-group">
                                        <button
                                            className="btn btn-primary"
                                            disabled={Cargando}
                                            onClick={() => {
                                                ExportaExcel(datos);
                                            }}
                                        >
                                            {Cargando ? 'Cargando...' : 'Descargar Excel'}
                                        </button>
                                    </div>
                                </div>}

                            </div>
                        </CardBody>
                    </Card>
                    {datos && beneficiariosReporte && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#7a6947' }}> Beneficiarios atendidos </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className="row" style={{ marginBottom: '16px' }}>
                                <div className="col-md-4">
                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '8px', padding: '16px' }}>
                                        <div style={{ fontSize: '16px', color: '#40635e' }}>Total beneficiarios</div>
                                        <div style={{ fontSize: '34px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>{formatoNumero(totalBeneficiarios)}</div>
                                        <div style={{ fontSize: '15px', color: '#40635e' }}>100.00% del total</div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div style={{ backgroundColor: '#e6f0ff', border: '1px solid #c8dbfb', borderRadius: '8px', padding: '16px' }}>
                                        <div style={{ fontSize: '16px', color: '#405170' }}>Total incluidos</div>
                                        <div style={{ fontSize: '34px', fontWeight: '700', color: '#2f3e5c', lineHeight: 1.1 }}>{formatoNumero(totalIncluidos)}</div>
                                        <div style={{ fontSize: '15px', color: '#405170' }}>{porcentajeIncluidos}% del total</div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div style={{ backgroundColor: '#fbe9f2', border: '1px solid #f4cfe1', borderRadius: '8px', padding: '16px' }}>
                                        <div style={{ fontSize: '16px', color: '#744661' }}>Total en valoraci&oacute;n</div>
                                        <div style={{ fontSize: '34px', fontWeight: '700', color: '#5f354f', lineHeight: 1.1 }}>{formatoNumero(totalValoraciones)}</div>
                                        <div style={{ fontSize: '15px', color: '#744661' }}>{porcentajeValoraciones}% del total</div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    {datos && beneficiariosPorSexo && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#486768' }}> Beneficiarios por sexo </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className='row'>
                                <div className="col-md-7">
                                    <div className="row g-0" style={{ marginBottom: '0px' }}>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Sexo</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Cantidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Incluido</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Valoración</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Porcentaje</div>
                                            </div>
                                        </div>
                                    </div>
                                    {beneficiariosPorSexo.length > 0 ? beneficiariosPorSexo.map((item) => {
                                        const cantidad = Number(item?.cantidad || 0);
                                        const incluido = Number(item?.incluido || 0);
                                        const valoracion = Number(item?.valoracion || 0);
                                        const porcentaje = basePorcentajeSexo > 0
                                            ? ((cantidad / basePorcentajeSexo) * 100).toFixed(2)
                                            : '0.00';

                                        return (
                                            <div key={item?.sexo || 'sexo_no_definido'} className="row g-0" style={{ marginBottom: '0px', marginRight: '0px', marginLeft: '0px' }}>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{capitalize(item?.sexo || 'Sexo no definido')}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{formatoNumero(cantidad)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{incluido}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{valoracion}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{porcentaje}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            No hay datos disponibles por sexo para el rango de fechas seleccionado.
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-5">
                                    {beneficiariosPorSexo.length > 0 ? (
                                        <div style={{ backgroundColor: '#fefcf6', border: '1px solid #f0e2c9', borderRadius: '10px', padding: '14px', height: '100%' }}>
                                            <div style={{ height: '240px' }}>
                                                <Pie data={graficaSexoData} options={graficaSexoOptions} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            Sin datos para generar la gr&aacute;fica.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    {datos && beneficiariosOrientacionSexual && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#7a6947' }}> Orientaci&oacute;n sexual </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className='row'>
                                <div className="col-md-5">
                                    {beneficiariosOrientacionSexual.length > 0 ? (
                                        <div style={{ backgroundColor: '#fefcf6', border: '1px solid #f0e2c9', borderRadius: '10px', padding: '14px', height: '100%' }}>
                                            <div style={{ height: '440px' }}>
                                                <Pie data={graficaOrientacionData} options={graficaOrientacionOptions} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            Sin datos para generar la gr&aacute;fica.
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-7">
                                    <div className="row g-0" style={{ marginBottom: '0px' }}>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Orientaci&oacute;n</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Cantidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Incluido</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Valoración</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '28px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Porcentaje</div>
                                            </div>
                                        </div>
                                    </div>
                                    {beneficiariosOrientacionSexual.length > 0 ? beneficiariosOrientacionSexual.map((item, index) => {
                                        const cantidad = Number(item?.cantidad || 0);
                                        const incluido = Number(item?.incluido || 0);
                                        const valoracion = Number(item?.valoracion || 0);
                                        const porcentaje = basePorcentajeOrientacion > 0
                                            ? ((cantidad / basePorcentajeOrientacion) * 100).toFixed(2)
                                            : '0.00';
                                        const orientacion = item?.ori_orientacionsexual ? capitalize(String(item.ori_orientacionsexual)) : 'No definida';

                                        return (
                                            <div key={`orientacion_${index}_${orientacion}`} className="row g-0" style={{ marginBottom: '0px', marginRight: '0px', marginLeft: '0px' }}>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{orientacion}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{formatoNumero(cantidad)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{formatoNumero(incluido)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{formatoNumero(valoracion)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '25px', color: '#40635e' }}>{porcentaje}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            No hay datos de orientaci&oacute;n sexual para el rango de fechas seleccionado.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    {datos && beneficiariosIdentidadGenero && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#7a6947' }}> Identidad de g&eacute;nero </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className='row'>
                                <div className="col-md-7">
                                    <div className="row g-0" style={{ marginBottom: '0px' }}>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Identidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Cantidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Incluido</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Valoración</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Porcentaje</div>
                                            </div>
                                        </div>
                                    </div>
                                    {beneficiariosIdentidadGenero.length > 0 ? beneficiariosIdentidadGenero.map((item, index) => {
                                        const cantidad = Number(item?.cantidad || 0);
                                        const incluido = Number(item?.incluido || 0);
                                        const valoracion = Number(item?.valoracion || 0);
                                        const porcentaje = basePorcentajeIdentidad > 0
                                            ? ((cantidad / basePorcentajeIdentidad) * 100).toFixed(2)
                                            : '0.00';
                                        const identidad = item?.ide_identidad ? capitalize(String(item.ide_identidad)) : 'No definida';

                                        return (
                                            <div key={`identidad_${index}_${identidad}`} className="row g-0" style={{ marginBottom: '0px', marginRight: '0px', marginLeft: '0px' }}>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{identidad}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(cantidad)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(incluido)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(valoracion)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{porcentaje}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            No hay datos de identidad de g&eacute;nero para el rango de fechas seleccionado.
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-5">
                                    {beneficiariosIdentidadGenero.length > 0 ? (
                                        <div style={{ backgroundColor: '#fefcf6', border: '1px solid #f0e2c9', borderRadius: '10px', padding: '14px', height: '100%' }}>
                                            <div style={{ height: '440px' }}>
                                                <Pie data={graficaIdentidadData} options={graficaIdentidadOptions} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            Sin datos para generar la gr&aacute;fica.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    {datos && beneficiariosEtareos && beneficiariosEtareos.length > 0 && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#7a6947' }}> Grupos et&aacute;reos </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className='row'>
                                <div className="col-md-7">
                                    <div className="row g-0" style={{ marginBottom: '0px' }}>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Grupo et&aacute;reo</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Cantidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Incluido</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Valoraci&oacute;n</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Porcentaje</div>
                                            </div>
                                        </div>
                                    </div>
                                    {beneficiariosEtareos.map((item, index) => {
                                        const cantidad = Number(item?.cantidad || 0);
                                        const incluido = Number(item?.incluido || 0);
                                        const valoracion = Number(item?.valoracion || 0);
                                        const porcentaje = basePorcentajeEtareos > 0
                                            ? ((cantidad / basePorcentajeEtareos) * 100).toFixed(2)
                                            : '0.00';
                                        const etareo = (item?.etareos || 'Sin Info').replace(/^\d/u, '').replaceAll('_', ' ').trim();

                                        return (
                                            <div key={`etareo_${item?.etareos || index}`} className="row g-0" style={{ marginBottom: '0px', marginRight: '0px', marginLeft: '0px' }}>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e', textAlign: 'center', wordBreak: 'break-word', width: '100%' }}>{etareo}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(cantidad)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(incluido)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(valoracion)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{porcentaje}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="col-md-5">
                                    <div style={{ backgroundColor: '#fefcf6', border: '1px solid #f0e2c9', borderRadius: '10px', padding: '14px', height: '100%' }}>
                                        <div style={{ height: '440px' }}>
                                            <Pie data={graficaEtareosData} options={graficaEtareosOptions} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    {datos && beneficiariosEtnias && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#7a6947' }}> Etnias </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className='row'>
                                <div className="col-md-5">
                                    {beneficiariosEtnias.length > 0 ? (
                                        <div style={{ backgroundColor: '#fefcf6', border: '1px solid #f0e2c9', borderRadius: '10px', padding: '14px', height: '100%' }}>
                                            <div style={{ height: '440px' }}>
                                                <Pie data={graficaEtniasData} options={graficaEtniasOptions} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            Sin datos para generar la gr&aacute;fica.
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-7">
                                    <div className="row g-0" style={{ marginBottom: '0px' }}>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '16px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Etnia</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '16px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Cantidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '16px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Incluido</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '16px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Valoración</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '16px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Porcentaje</div>
                                            </div>
                                        </div>
                                    </div>
                                    {beneficiariosEtnias.length > 0 ? beneficiariosEtnias.map((item, index) => {
                                        const cantidad = Number(item?.cantidad || 0);
                                        const incluido = Number(item?.incluido || 0);
                                        const valoracion = Number(item?.valoracion || 0);
                                        const porcentaje = basePorcentajeEtnias > 0
                                            ? ((cantidad / basePorcentajeEtnias) * 100).toFixed(2)
                                            : '0.00';
                                        const etnia = item?.min_minoria ? capitalize(String(item.min_minoria)) : 'No definida';

                                        return (
                                            <div key={`etnia_${index}_${etnia}`} className="row g-0" style={{ marginBottom: '0px', marginRight: '0px', marginLeft: '0px' }}>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '16px', color: '#40635e' }}>{etnia}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '16px', color: '#40635e' }}>{formatoNumero(cantidad)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '16px', color: '#40635e' }}>{formatoNumero(incluido)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '16px', color: '#40635e' }}>{formatoNumero(valoracion)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '16px', color: '#40635e' }}>{porcentaje}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            No hay datos de etnias para el rango de fechas seleccionado.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    {datos && beneficiariosDiscapacidades && <Card style={{ marginTop: '20px' }}>
                        <CardHeader style={{ backgroundColor: '#fff5e6', borderBottom: '1px solid #f6ddbc' }}>
                            <h3 className="card-title" style={{ fontSize: '24px', fontWeight: 700, color: '#7a6947' }}> Discapacidades </h3>
                        </CardHeader>
                        <CardBody style={{ backgroundColor: '#fffdf9' }}>
                            <div className='row'>
                                <div className="col-md-7">
                                    <div className="row g-0" style={{ marginBottom: '0px' }}>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Discapacidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Cantidad</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Incluido</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Valoraci&oacute;n</div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#2f4f4a', lineHeight: 1.1 }}>Porcentaje</div>
                                            </div>
                                        </div>
                                    </div>
                                    {beneficiariosDiscapacidades.length > 0 ? beneficiariosDiscapacidades.map((item) => {
                                        const cantidad = Number(item?.cantidad || 0);
                                        const incluido = Number(item?.incluido || 0);
                                        const valoracion = Number(item?.valoracion || 0);
                                        const porcentaje = basePorcentajeDiscapacidades > 0
                                            ? ((cantidad / basePorcentajeDiscapacidades) * 100).toFixed(2)
                                            : '0.00';
                                        const discapacidad = item?.dis_discapacidad ? capitalize(String(item.dis_discapacidad)) : 'No definida';
                                        const filaKey = `discapacidad_${String(item?.dis_discapacidad || 'sin_info')}_${cantidad}_${incluido}_${valoracion}`;

                                        return (
                                            <div key={filaKey} className="row g-0" style={{ marginBottom: '0px', marginRight: '0px', marginLeft: '0px' }}>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e', textAlign: 'center', wordBreak: 'break-word', width: '100%' }}>{discapacidad}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(cantidad)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(incluido)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{formatoNumero(valoracion)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div style={{ backgroundColor: '#dff3f0', border: '1px solid #c2e8e2', borderRadius: '0px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <div style={{ fontSize: '14px', color: '#40635e' }}>{porcentaje}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            No hay datos de discapacidades para el rango de fechas seleccionado.
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-5">
                                    {beneficiariosDiscapacidades.length > 0 ? (
                                        <div style={{ backgroundColor: '#fefcf6', border: '1px solid #f0e2c9', borderRadius: '10px', padding: '14px', height: '100%' }}>
                                            <div style={{ height: '440px' }}>
                                                <Pie data={graficaDiscapacidadesData} options={graficaDiscapacidadesOptions} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ padding: '16px', backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '8px', color: '#a94442' }}>
                                            Sin datos para generar la gr&aacute;fica.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>}
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
            didClose={() => {
                setSwalProps({})
            }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}